export default ({ href = '/shop/back-to-school', className = '' }) => {
    return (
        <a href={href} className={`back-to-school-banner ${className}`.trim()}>
            <img
                className="back-to-school-banner__title"
                src="/img/sales/backtoschool2026/back-to-school.png"
                alt="Back to School"
            />
            <span className="back-to-school-banner__copy">
                <strong>Frames + Lenses</strong> starting at $99
            </span>
            <span className="back-to-school-banner__cta">Shop Now</span>
        </a>
    )
}
